export const DisplayStates = {
    NO_SCORES: 1,
    WINNER_NOT_DECIDED: 2,
    WINNER_DECIDED: 3,
};

export const OutComeTypes = {
    DEFAULTED: 'defaulted',
    WITHDREW: 'withdrew',
    RETIRED: 'retired',
    INCOMPLETE: 'incomplete',
    COMPLETE: 'tied match',
    COMPLETED: 'completed',
    FORFEIT: 'forfeit',
    ABANDONED: 'abandoned match',
    DOUBLEWALKOVER: 'double walkover',
};

export const CompletionTypes = {
    WINNER_DID_NOT_START: 'winnerdidnotstart',
    TIE_INCOMPLETE: 'tieincomplete',
    TIE_COMPLETED: 'tiecompleted',
    WINNER_COMPLETED: 'winnercompleted',
    WINNER_INCOMPLETE: 'winnerincomplete',
};

export const DefaultSets = [
    { id: 0, pos1Score: '', pos2Score: '', pos1TieBrk: '', pos2TieBrk: '' },
    { id: 1, pos1Score: '', pos2Score: '', pos1TieBrk: '', pos2TieBrk: '' },
    { id: 2, pos1Score: '', pos2Score: '', pos1TieBrk: '', pos2TieBrk: '' },
];

export const WalkOverValues = [
    'Walkover',
    'Defaulted',
    'Withdrew',
    'Double Default',
    'Abandoned Match',
    'Double Walkover',
    'walkover',
    'defaulted',
    'withdrew',
    'double default',
    'abandoned match',
    'double walkover',
];

export const RetiredValues = [
    'Retired',
    'Injury',
    'retired',
    'injury',
];

export const ForfeitValues = [
    'forfeit',
];

export const MatchFormatTypes = {
    SINGLES: 'singles',
    DOUBLES: 'doubles',
};

export const PlayerTypes = {
    WINNER: 'winner',
    LOSER: 'loser',
};

export const AbandonedMatchLabel = 'Abandoned Match';
export const DefaultedLabel = 'Defaulted';
export const DoubleWalkoverLabel = 'Double Walkover';
export const WithdrewLabel = 'Withdrew';
export const position1 = 'pos1';
export const position2 = 'pos2';
export const MIN_GAME_DIFF_FOR_NON_TIED_SET = 2;

// Other files still hardcode these values: ScoreCard, FlexLeagueMatchCard, PickleballPostScoreForm,
// MatchV2, EventProfileHeader, FlexLeagueMatchCards, PostScorePage
export const RedirectUrlPages = {
    FLEX_LEAGUE: 'FlexLeagues',
    EVENT_DESK_POST: 'EventDeskPost',
};
